import React from "react"
import { createRoot, Root } from "react-dom/client"

import ThemeToggle from "./ThemeToggle"
import FireComputerScene from "./FireComputerScene"
import AutomationScene from "./AutomationScene"
import QualityHubScene from "./QualityHubScene"
import StructureScene from "./StructureScene"
import DevelopScene from "./DevelopScene"
import PreventScene from "./PreventScene"
import FireTruckScene from "./FireTruckScene"

type IslandProps = Record<string, any>

// Registry (scheelt al die ifs + is sneller/strakker)
const registry: Record<string, React.ComponentType<any>> = {
    ThemeToggle,
    FireComputerScene,
    AutomationScene,
    QualityHubScene,
    StructureScene,
    DevelopScene,
    PreventScene,
    FireTruckScene,
}

function safeParseProps(el: HTMLElement): IslandProps {
    if (!el.dataset.props) return {}
    try {
        return JSON.parse(el.dataset.props)
    } catch {
        return {}
    }
}

function mountIslands(scope: ParentNode = document) {
    scope.querySelectorAll<HTMLElement>("[data-island]").forEach((el) => {
        // voorkom dubbele mount (bijv. turbo:load + turbo:frame-load)
        if (el.dataset.mounted === "1") return

        const name = el.dataset.island
        if (!name) return

        const Component = registry[name]
        if (!Component) return

        const props = safeParseProps(el)

        const root = createRoot(el)
            ; (el as any).__reactRoot = root
        el.dataset.mounted = "1"

        root.render(<Component {...props} />)
    })
}

function unmountIslands() {
    document.querySelectorAll<HTMLElement>("[data-island]").forEach((el) => {
        const root = (el as any).__reactRoot as Root | undefined
        if (root) {
            root.unmount()
                ; (el as any).__reactRoot = undefined
        }
        el.dataset.mounted = "0"
    })
}

// 1) Eerste load + elke Turbo page visit
document.addEventListener("turbo:load", () => {
    mountIslands(document)
})

// 2) Als je Turbo Frames gebruikt
document.addEventListener("turbo:frame-load", (e) => {
    // e.target is het frame element
    mountIslands(e.target as ParentNode)
})

// 3) Belangrijk: Turbo cached de pagina (snapshot). Haal React eruit vóór cache.
document.addEventListener("turbo:before-cache", () => {
    unmountIslands()
})

// 4) Fallback voor het geval Turbo niet actief is (rechtstreeks geladen pagina)
if (!("Turbo" in window)) {
    // DOMContentLoaded is dan ok
    document.addEventListener("DOMContentLoaded", () => mountIslands(document))
}
